import { testImageConstants } from "../_redux-constants";
import { testImageService } from "../../_services";

function getTestImage(testImage) {
  function testImageLoad() {
    return { type: testImageConstants.TEST_IMAGE_LOADING };
  }
  function testImageSuccess(data) {
    return { type: testImageConstants.TEST_IMAGE_SUCCESS, data };
  }
  function testImageFailure(error) {
    return { type: testImageConstants.TEST_IMAGE_FAILURE, error };
  }
  return (dispatch) => {
    dispatch(testImageLoad());
    testImageService.getTestImages(testImage).then(
      (data) => {
        dispatch(testImageSuccess(data));
      },
      (error) => {
        dispatch(testImageFailure(error?.toString()));
      }
    );
  };
}

export const testImageActions = {
  getTestImage,
};
